import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import UnclaimedBusinessProfile from '../BusinessProfileCard/components/UnclaimedBusinessProfile'
import api from 'api'
import { styled } from '@mui/material/styles'
import BusinessInformation from './BusinessInformation'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: '40px 25px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

function BusinessCard() {
  const [businessData, setBusinessData] = useState({})
  const [businessProfileCompletion, setBusinessProfileCompletion] = useState(0)
  const [userProfileCompletion, setUserProfileCompletion] = useState(0)
  const user = useSelector(state => state.userReducer.user)

  useEffect(() => {
    if (!user) return
    fetchAndSetData()
  }, [user])

  const fetchAndSetData = async () => {
    const data = await api.getDashboardInfo()
    if (data?.business_info?.business_profile_completion)
      setBusinessProfileCompletion(parseInt(data?.business_info?.business_profile_completion))
    if (data?.user_info?.profile_completion) setUserProfileCompletion(parseInt(data?.user_info?.profile_completion))

    if (data.business_info?.claimed_business_details) {
      setBusinessData(data.business_info?.claimed_business_details)
      return
    }
  }

  return (
    <>
      <ProfileCardContainer>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '250px',
          }}
        >
          {businessData?.isClaimed ? (
            <BusinessInformation
              businessData={businessData}
              userProfileCompletion={userProfileCompletion}
              businessProfileCompletion={businessProfileCompletion}
            />
          ) : (
            <UnclaimedBusinessProfile />
          )}
        </Box>
      </ProfileCardContainer>
    </>
  )
}

export default BusinessCard
